<lib-rnimu-quiz *ngIf="variantId"
                [variantId]="variantId"
                [accessibleMode]="getAccessibleModeState"
                [connectionRefused$]="getConnectionRefused"
                [connectionLost$]="getConnectionLost"
                (variantTitle)="setVariantTitle($event)"
>
</lib-rnimu-quiz>
